// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6f121827","365":"4f18e409","366":"d1d6c5f2","485":"9b694ac4","501":"f4ef55e3","734":"c566dc94"}[chunkId] + ".chunk.js";
};